var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEnhancementIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "29px",
    viewBox: "0 0 26 29",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0.000541666667 26.0010674 0.000541666667 26.0010674 28.1658 0 28.1658"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Boost",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "INSURANCE-//-Payment-Copy-26",
    transform: "translate(-25.000000, -108.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(25.000000, 108.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-enhancement-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.38408333,18.3935917 L12.4583333,21.9003417 C12.7941667,22.093175 13.2069167,22.093175 13.5416667,21.9003417 L19.617,18.3935917 L22.75,20.2027583 L13,25.8317583 L3.25,20.2027583 L6.38408333,18.3935917 Z M6.38625,12.274925 L12.4583333,15.7805917 C12.7941667,15.9745083 13.2069167,15.9745083 13.5416667,15.7805917 L19.6148333,12.274925 L22.75,14.0830083 L13,19.7120083 L3.25,14.0830083 L6.38625,12.274925 Z M13.026,-0.000585347711 C12.8266667,-0.00465833333 12.6316667,0.045175 12.4583333,0.143758333 L0.541666667,7.02509167 C0.0238333333,7.325175 -0.151666667,7.988175 0.148416667,8.50600833 C0.242666667,8.66850833 0.379166667,8.80500833 0.541666667,8.89925833 L4.21741667,11.0215083 L0.541666667,13.1437583 C0.0238333333,13.4438417 -0.153833333,14.1057583 0.145166667,14.624675 C0.2405,14.7893417 0.377,14.9258417 0.541666667,15.021175 L4.21741667,17.1412583 L0.541666667,19.2635083 C0.0238333333,19.5625083 -0.153833333,20.2255083 0.145166667,20.7422583 C0.2405,20.9080083 0.377,21.0455917 0.541666667,21.140925 L12.4583333,28.021175 C12.7941667,28.2140083 13.2069167,28.2140083 13.5416667,28.021175 L25.4583333,21.140925 C25.97725,20.8408417 26.1549167,20.178925 25.8559167,19.6600083 C25.7605833,19.4953417 25.6240833,19.3588417 25.4583333,19.2635083 L21.7836667,17.1412583 L25.4583333,15.021175 C25.97725,14.722175 26.1549167,14.059175 25.8559167,13.5413417 C25.7605833,13.376675 25.6240833,13.2390917 25.4583333,13.1437583 L21.7836667,11.0215083 L25.4583333,8.89925833 C25.9761667,8.599175 26.15275,7.93725833 25.8526667,7.419425 C25.7584167,7.25584167 25.6219167,7.11934167 25.4583333,7.02509167 L13.5416667,0.143758333 C13.3845833,0.0538416667 13.2069167,0.00400833333 13.026,-0.000585347711 L13.026,-0.000585347711 Z",
    id: "Fill-1",
    fill: "#FDFDFB",
    mask: "url(#mask-enhancement-2)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnhancementIcon);
export default __webpack_public_path__ + "static/media/enhancement_icon.2f3dac79.svg";
export { ForwardRef as ReactComponent };